import { render, staticRenderFns } from "./bookingList.vue?vue&type=template&id=3271c280&scoped=true"
import script from "./bookingList.vue?vue&type=script&lang=js"
export * from "./bookingList.vue?vue&type=script&lang=js"
import style0 from "./bookingList.vue?vue&type=style&index=0&id=3271c280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3271c280",
  null
  
)

export default component.exports